import { useAuthStore } from "@/pages/Login/store";
import { Navigate } from "react-router-dom";
import { paths } from "./paths";

type Props = {
  children: React.ReactNode;
};

export const UnauthenticatedRoute = ({ children }: Props) => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  
  if (isLoggedIn) {
    return <Navigate to={paths.ROOT} replace />;
  }
  return <>{children}</>;
};
